import { imageStore } from '../images.js';
import Drawable from '../entities/Drawable.js';
import Sprite from './Sprite.js';
import PixelText from './PixelText.js';

export default class OptionsBox extends Drawable {
    constructor({ options, position = { x: 0, y: 0 }, visible = false, selectedOption = 0, wide = false }) {
        super();
        this.options = options;
        this.selectedOption = selectedOption;
        this.position = position;
        this.visible = visible;
        this.wide = wide;
        let optionsBoxImage = null;
        switch (options.length) {
            case 7:
            case 6:
                if (this.wide) {
                    optionsBoxImage = imageStore.get('img/pause_menu_box_112_wide.png');
                } else {
                    optionsBoxImage = imageStore.get('img/pause_menu_box_112.png');
                }
                break;
            case 5:
                optionsBoxImage = imageStore.get('img/pause_menu_box.png');
                break;
            case 4:
                optionsBoxImage = imageStore.get('img/menu_box_80x80_empty.png');
                break;
            case 3:
                optionsBoxImage = imageStore.get('img/menu_box_64x64_empty.png');
                break;
            case 2:
            case 1:
                optionsBoxImage = imageStore.get('img/menu_box_64x48_empty.png');
                break;
        }
        this.sprites = {};
        this.sprites.optionsBox = new Sprite({
            position: { x: this.position.x, y: this.position.y },
            image: optionsBoxImage,
            moving: false,
            frames: { max: 1, val: 0 },
            visible: true,
        });
        this.optionsTextArray = [];
        this.options.forEach((option, i) => {
            this.optionsTextArray.push(
                new PixelText({
                    text: option,
                    position: {
                        x: this.position.x + 16,
                        y: this.position.y + 12 + i * 16,
                    },
                    color: 'black',
                })
            );
        });

        this.sprites.selectionArrow = new Sprite({
            position: {
                x: this.position.x + 8,
                y: this.position.y + 12 + 16 * this.selectedOption,
            },
            image: imageStore.get('img/selection_arrow.png'),
            moving: false,
            frames: { max: 1, val: 0 },
        });
    }

    setOptions(options, wide = false) {
        this.options = options;
        let optionsBoxImage = null;
        switch (options.length) {
            case 7:
            case 6:
                if (wide) {
                    optionsBoxImage = imageStore.get('img/pause_menu_box_112_wide.png');
                } else {
                    optionsBoxImage = imageStore.get('img/pause_menu_box_112.png');
                }
                break;
            case 5:
                this.position = { x: 168, y: 64 };
                optionsBoxImage = imageStore.get('img/pause_menu_box.png');
                break;
            case 4:
                optionsBoxImage = imageStore.get('img/menu_box_80x80_empty.png');
                this.position = { x: 160, y: 80 };
                break;
            case 3:
                optionsBoxImage = imageStore.get('img/menu_box_64x64_empty.png');
                this.position = { x: 176, y: 96 };
                break;
            case 2:
            case 1:
                optionsBoxImage = imageStore.get('img/menu_box_64x48_empty.png');
                break;
        }
        this.sprites.optionsBox.position = this.position;
        this.sprites.optionsBox.setImage(optionsBoxImage);
    }

    draw() {
        if (!this.visible) {
            return;
        }

        this.optionsTextArray = [];
        this.options.forEach((option, i) => {
            this.optionsTextArray.push(
                new PixelText({
                    text: option,
                    position: {
                        x: this.position.x + 16,
                        y: this.position.y + 12 + i * 16,
                    },
                    color: PixelText.blackTextColor,
                    shadowColor: PixelText.whiteShadowColor,
                    fontType: 'small',
                })
            );
        });
        this.sprites.optionsBox.draw();
        this.optionsTextArray.forEach((option) => {
            option.draw();
        });
        this.sprites.selectionArrow.position = {
            x: this.position.x + 8,
            y: this.position.y + 12 + 16 * this.selectedOption,
        };
        this.sprites.selectionArrow.draw();
    }
}
